import { Injectable } from '@angular/core';
import {Headers, Http, Response} from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import {Evento} from "./evento";
import {AppService} from "../app.service";
import {HEADERS} from "../constante";
// import { Evento } from './evento';

@Injectable()
export class EventosService extends AppService {


    documentoUrl = URL_API + '/evento';

	save(evento: Evento): Promise<Response> {
        return this.http
            .post(this.documentoUrl, this.utils.buildFormData(evento))
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
	
	update(evento: Evento): Promise<Response> {
        return this.http
            .post(this.documentoUrl + '/update', this.utils.buildFormData(evento))
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
	
	buscarAluno(cpf: string): Promise<any> {
        return this.http.get(URL_API + '/usuario/jsonCPF/' + cpf, {headers: HEADERS}).toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }
	
	buscarUltimo(): Promise<any> {
        return this.http.get(this.documentoUrl + '/ultimo', {headers: HEADERS}).toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/eventos/eventos.service.ts